import { Dispatch } from 'redux';
import api from '../../services/api';
import { getForms } from '../../graphql/queries';
import { GET_FORMS, GET_FORMS_COMPLETED, GET_FORMS_FAILED } from './types';

function get(ContactID?: string) {
  return async function action(dispatch: Dispatch) {
    dispatch({
      type: GET_FORMS,
    });

    try {
      const { data } = await api.graphql({
        query: getForms,
        variables: {
          ContactID,
        },
      });

      dispatch({
        payload: data?.getForms.items,
        type: GET_FORMS_COMPLETED,
      });
    } catch (e) {
      dispatch({
        payload: e,
        type: GET_FORMS_FAILED,
      });
    }
  };
}

export default get;
